import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: 'hr, br',
  standalone: false
})
export class AriaHiddenDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer?.setAttribute(this.el.nativeElement, 'aria-hidden', 'true');
  }
}